import React, { useState } from "react";
import "./HireFarmLabour.css";
import { Col, Row } from "react-bootstrap";
import contractor from "../../assets/images/png/contractor.png";
import individual from "../../assets/images/png/individual.png";
import farmer from "../../assets/images/png/farmer.png";
import calendarImg from "../../assets/images/svg/calender.svg";
import greenClock from "../../assets/images/svg/greenClock.svg";
import Calendar from "react-calendar";
import Form from "react-bootstrap/Form";
import FeatureAdds from "../AllProdutcs/FeatureAdds";
import {
  uploadContractorData,
  uploadFarmerData,
  uploadIndividualData,
} from "../../services/HireFarmLabourServices";
import { ToastContainer, toast } from "react-toastify";

const HireFarmLabour = () => {
  const [hirer, setHirer] = useState(0);
  const [value, setValue] = useState(null);
  const [showCalendar, setshowCalendar] = useState(false);
  const [hirerContent] = useState([
    {
      img: contractor,
      name: "Contractor",
    },
    {
      img: individual,
      name: "Individual",
    },
    {
      img: farmer,
      name: "Farmer",
    },
  ]);

  const [contractorData, setContractorData] = useState({
    name: "",
    adharNumber: "",
    mobile: Number,
    email: "",
    location: "",
    numberOfLabourWorker: Number,
    averagePrice: Number,
    datesOfAvilability: value,
    specialisation: "",
    workTiming: "",
    termAndCondition: "",
    accountNumber: "",
    city: "",
    workType: "",
    IFSCcode: "",
  });
  const [individualData, setIndividualData] = useState({
    name: "",
    adharNumber: "",
    mobile: Number,
    email: "",
    location: "",
    numberOfLabourWorker: Number,
    averagePrice: Number,
    datesOfAvilability: value,
    specialisation: "",
    workTiming: "",
    termAndCondition: "",
    accountNumber: "",
    city: "",
    workType: "",
    IFSCcode: "",
  });
  const [farmerData, setFarmerData] = useState({
    name: "",
    adharNumber: "",
    mobile: Number,
    email: "",
    location: "",
    numberOfLabour: Number,
    duration: value,
    agricultureLand: "",
    termAndCondition: "",
    workType: "",
    detailsOfCrop: "",
  });

  const handleIndividualDataChange = (e) => {
    const { name, value } = e.target;
    setIndividualData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFarmerDataChange = (e) => {
    const { name, value } = e.target;
    setFarmerData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const isEmailValid = (email) => {
    // Regular expression for basic email format validation
    const emailFormat = /\S+@\S+\.\S+/;
    return emailFormat.test(email);
  };

  const isFormValid = () => {
    let requiredFields = [];
    if (hirer === 0) {
      requiredFields = [
        "name",
        "adharNumber",
        "mobile",
        "email",
        "location",
        "numberOfLabourWorker",
        "averagePrice",
        "workTiming",
        "accountNumber",
        "workType",
      ];
      // Check if all required fields are not empty and email is valid
      return (
        requiredFields.every((field) => contractorData[field] !== "") &&
        isEmailValid(contractorData.email)
      );
    } else if (hirer === 1) {
      requiredFields = [
        "name",
        "adharNumber",
        "mobile",
        "email",
        "location",
        "numberOfLabourWorker",
        "averagePrice",
        "workTiming",
        "accountNumber",
        "workType",
      ];
      // Check if all required fields are not empty and email is valid
      return (
        requiredFields.every((field) => individualData[field] !== "") &&
        isEmailValid(individualData.email)
      );
    } else if (hirer === 2) {
      requiredFields = [
        "name",
        "agricultureLand",
        "mobile",
        "email",
        "location",
        "numberOfLabour",
        "duration",
        "detailsOfCrop",
      ];
      // Check if all required fields are not empty and email is valid
      return (
        requiredFields.every((field) => farmerData[field] !== "") &&
        isEmailValid(farmerData.email)
      );
    }
    return false;
  };

  const handleHirerChange = (hirerIndex) => {
    setHirer(hirerIndex);
    if (hirerIndex === 0) {
      setContractorData({
        name: "",
        adharNumber: "",
        mobile: "",
        email: "",
        location: "",
        numberOfLabourWorker: "",
        averagePrice: "",
        datesOfAvilability: value,
        specialisation: "",
        workTiming: "",
        termAndCondition: "",
        accountNumber: "",
        city: "",
        workType: "",
        IFSCcode: "",
      });
    } else if (hirerIndex === 1) {
      setIndividualData({
        name: "",
        adharNumber: "",
        mobile: "",
        email: "",
        location: "",
        numberOfLabourWorker: "",
        averagePrice: "",
        datesOfAvilability: value,
        specialisation: "",
        workTiming: "",
        termAndCondition: "",
        accountNumber: "",
        city: "",
        workType: "",
        IFSCcode: "",
      });
    } else if (hirerIndex === 2) {
      setFarmerData({
        name: "",
        adharNumber: "",
        mobile: "",
        email: "",
        location: "",
        numberOfLabour: "",
        duration: value,
        agricultureLand: "",
        termAndCondition: "",
        workType: "",
        detailsOfCrop: "",
      });
    }
  };

  const sendContractorData = async () => {
    if (!isFormValid()) {
      toast.error("Please fill in all required fields");
      return;
    }
    let response;
    if (hirer === 0) {
      response = await uploadContractorData(contractorData);
    } else if (hirer === 1) {
      response = await uploadIndividualData(individualData);
    } else {
      response = await uploadFarmerData(farmerData);
    }
    if (response.status === "success") {
      setValue(null);
      setContractorData({
        name: "",
        adharNumber: "",
        mobile: "",
        email: "",
        location: "",
        numberOfLabourWorker: "",
        averagePrice: "",
        datesOfAvilability: value,
        specialisation: "",
        workTiming: "",
        termAndCondition: "",
        accountNumber: "",
        city: "",
        workType: "",
        IFSCcode: "",
      });
      setIndividualData({
        name: "",
        adharNumber: "",
        mobile: "",
        email: "",
        location: "",
        numberOfLabourWorker: "",
        averagePrice: "",
        datesOfAvilability: value,
        specialisation: "",
        workTiming: "",
        termAndCondition: "",
        accountNumber: "",
        city: "",
        workType: "",
        IFSCcode: "",
      });
      setFarmerData({
        name: "",
        agricultureLand: "",
        mobile: "",
        email: "",
        numberOfLabourWorker: "",
        detailsOfCrop: "",
        duration: "",
        workType: "",
        numberOfLabourRequired: "",
        termAndCondition: "",
      });
      toast.success("Form submitted successfully");
    } else {
      toast.error("Something went wrong");
    }
  };

  if (!showCalendar) {
    document.body.style.overflow = "visible";
  } else {
    document.body.style.overflow = "hidden";
  }
  const formatDate = (timestamp) => {
    if (!timestamp) {
      return "Select a date";
    }
    const date = new Date(timestamp);
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };
  return (
    <div className="bg_clr_light_green pb-5 pt-4">
      <ToastContainer />
      <div
        onClick={() => setshowCalendar(false)}
        className={`over-lay position-fixed  ${
          showCalendar === true ? "d-block" : "d-none"
        }`}
      ></div>
      <div className="container">
        <Row>
          <Col lg={9}>
            <div className="bg-white p-sm-5 p-4 rounded-2">
              <h2 className="ff_heebo fw-bold fs_4xl clr_dark_blue_2">
                Hire Farm <span className="clr_dark_green">Labour</span>
              </h2>
              <div className="d-flex align-items-center gap-3 mt-4 farm-labour-card-div">
                {hirerContent.map((value, index) => (
                  <div
                    key={index}
                    onClick={() => handleHirerChange(index)}
                    className={`hire-labour-cards ${
                      hirer === index ? "bg_dark_green" : "bg_clr_light_green"
                    } rounded-2 d-flex flex-column justify-content-center align-items-center cursor_pointer`}
                  >
                    <div className="text-center">
                      <img
                        className="farm-labour-image"
                        src={value.img}
                        alt={value.name}
                      />
                      <p
                        className={`mb-0 ${
                          hirer === index ? "text-white" : "clr_dark_blue"
                        }  ff_poppins fw-medium labour-font-size mt-2`}
                      >
                        {value.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="mt-5 p-md-5 p-4 bg-white rounded-2 position-relative">
              <h2 className="mb-0 ff_heebo fw-bold clr_dark_blue fs_6xl_2">
                Register
              </h2>
              <p className="text-dark-grey mb-0 ff_heebo fs_xsm mt-2">
                Setup{" "}
                {hirer === 0
                  ? "Contractor"
                  : hirer === 1
                  ? "Individual"
                  : "Farmer"}{" "}
                account in a minute.
              </p>
              {hirer === 0 ? (
                <div>
                  <div className="mt-4 d-md-flex gap-5 gap-lg-5 align-items-center justify-content-between">
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="Name"
                      value={contractorData.name}
                      onChange={(e) => {
                        setContractorData({
                          ...contractorData,
                          name: e.target.value,
                        });
                      }}
                    />
                    <input
                      className="register-inputs mt-4 mt-md-0 px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="Registration number or Aadhar number"
                      value={contractorData.adharNumber}
                      maxLength="16"
                      onChange={(e) => {
                        const re = /^[0-9\b]+$/;
                        if (e.target.value === "" || re.test(e.target.value)) {
                          setContractorData({
                            ...contractorData,
                            adharNumber: e.target.value,
                          });
                        }
                      }}
                    />
                  </div>
                  <div className="mt-4 d-md-flex gap-5 gap-lg-5 align-items-center justify-content-between">
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="tel"
                      placeholder="Mobile"
                      value={contractorData.mobile}
                      maxLength={10}
                      onInput={(e) => {
                        e.target.value = e.target.value
                          .replace(/[^0-9]/g, "")
                          .slice(0, 10);
                      }}
                      onChange={(e) => {
                        setContractorData({
                          ...contractorData,
                          mobile: e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 10),
                        });
                      }}
                    />
                    <input
                      className="register-inputs mt-4 mt-md-0 px-3 clr_dark_grey_4"
                      type="email"
                      placeholder="Email Id"
                      value={contractorData.email}
                      onChange={(e) => {
                        setContractorData({
                          ...contractorData,
                          email: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="mt-4 d-md-flex gap-5 gap-lg-5 align-items-center justify-content-between">
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="number"
                      placeholder="Number of labour worker"
                      value={contractorData.numberOfLabourWorker}
                      onChange={(e) => {
                        setContractorData({
                          ...contractorData,
                          numberOfLabourWorker: e.target.value,
                        });
                      }}
                    />
                    <input
                      className="register-inputs mt-4 mt-md-0 px-3 clr_dark_grey_4"
                      type="number"
                      placeholder="Average price per day /per labour "
                      value={contractorData.averagePrice}
                      onChange={(e) => {
                        setContractorData({
                          ...contractorData,
                          averagePrice: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="mt-4 d-md-flex gap-5 gap-lg-5 align-items-center justify-content-between">
                    <div
                      onClick={() => setshowCalendar(true)}
                      className="w-100 d-flex align-items-center register-inputs pe-2 cursor_pointer"
                    >
                      <input
                        className="register-inputs bg-transparent border-0 px-3 clr_dark_grey_4"
                        type="text"
                        value={formatDate(value)}
                        placeholder="Dates of availability"
                        disabled
                      />
                      <img
                        className="border-0"
                        src={calendarImg}
                        alt="calendar"
                      />
                      <div
                        className={`position-fixed date-calendar z-2 ${
                          showCalendar === true ? "d-block" : "d-none"
                        }`}
                      >
                        <Calendar
                          minDate={new Date()}
                          value={value}
                          onClickDay={(e) => {
                            setValue(e);
                            setshowCalendar(false);
                          }}
                        />
                      </div>
                    </div>
                    <div className="register-inputs mt-4 mt-md-0 w-100">
                      <Form.Select
                        value={contractorData.workType || ""}
                        onChange={(e) => {
                          setContractorData({
                            ...contractorData,
                            workType: e.target.value,
                          });
                        }}
                        className="register-inputs bg-transparent border-0 px-3 clr_dark_grey_4"
                      >
                        <option value="" disabled>
                          Work type
                        </option>
                        <option value="Pre harvest">Pre harvest</option>
                        <option value="Post harvest">Post harvest</option>
                      </Form.Select>
                    </div>
                  </div>
                  <div className="mt-4 d-md-flex gap-5 gap-lg-5 align-items-center justify-content-between">
                    <div className="register-inputs d-flex align-items-center">
                      <input
                        className="register-inputs border-1 px-3 clr_dark_grey_4"
                        type="number"
                        placeholder="Work timings in Hours"
                        value={contractorData.workTiming}
                        onChange={(e) => {
                          setContractorData({
                            ...contractorData,
                            workTiming: e.target.value,
                          });
                        }}
                      />
                      {/* <img src={greenClock} alt="" /> */}
                    </div>

                    <input
                      className="register-inputs mt-4 mt-md-0 px-3 clr_dark_grey_4"
                      type="text" // ⚠️ Use "text" instead of "number" to allow control over leading zeros & length
                      placeholder="Account Number"
                      value={contractorData.accountNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        // Allow only digits
                        const numericOnly = value.replace(/\D/g, "");
                        setContractorData({
                          ...contractorData,
                          accountNumber: numericOnly,
                        });
                      }}
                      maxLength={18}
                    />
                  </div>
                  <div className="mt-4 d-md-flex gap-5 gap-lg-5 align-items-center justify-content-between">
                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="IFSC Code"
                      maxLength={11} // IFSC code is exactly 11 characters
                      value={contractorData.IFSCcode}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase(); // Convert to uppercase
                        const alphanumericOnly = value.replace(
                          /[^A-Z0-9]/g,
                          ""
                        ); // Remove non-alphanumeric
                        setContractorData({
                          ...contractorData,
                          IFSCcode: alphanumericOnly,
                        });
                      }}
                    />

                    <input
                      className="register-inputs px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="Location"
                      value={contractorData.location}
                      onChange={(e) => {
                        setContractorData({
                          ...contractorData,
                          location: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="mt-4 d-md-flex gap-5 gap-lg-5 align-items-center justify-content-between">
                    <input
                      className="register-inputs mt-4 mt-md-0 px-3 clr_dark_grey_4"
                      type="text"
                      placeholder="Any Terms and Condition"
                      value={contractorData.termAndCondition}
                      onChange={(e) => {
                        setContractorData({
                          ...contractorData,
                          termAndCondition: e.target.value,
                        });
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  {hirer === 1 ? (
                    <div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Name"
                          name="name"
                          value={individualData.name}
                          onChange={handleIndividualDataChange}
                        />
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Aadhar number"
                          name="adharNumber"
                          maxLength="16"
                          value={individualData.adharNumber}
                          onChange={(e) => {
                            const re = /^[0-9\b]+$/;
                            if (
                              e.target.value === "" ||
                              re.test(e.target.value)
                            ) {
                              handleIndividualDataChange(e);
                            }
                          }}
                        />
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="tel"
                          placeholder="Mobile"
                          name="mobile"
                          value={individualData.mobile}
                          maxLength={10}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/[^0-9]/g, "")
                              .slice(0, 10);
                          }}
                          onChange={handleIndividualDataChange}
                        />
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="email"
                          placeholder="Email Id"
                          name="email"
                          value={individualData.email}
                          onChange={(e) => {
                            handleIndividualDataChange(e);
                          }}
                        />
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Number of labour worker"
                          name="numberOfLabourWorker"
                          value={individualData.numberOfLabourWorker}
                          onChange={handleIndividualDataChange}
                        />
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Average price per day"
                          name="averagePrice"
                          value={individualData.averagePrice}
                          onChange={handleIndividualDataChange}
                        />
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <div
                          onClick={() => setshowCalendar(true)}
                          className="w-100 d-flex align-items-center date-input-div pe-2 cursor_pointer"
                        >
                          <input
                            className="register-inputs bg-transparent border-0 px-3 clr_dark_grey_4"
                            type="text"
                            value={formatDate(value)}
                            placeholder="Dates of availability"
                            disabled
                          />
                          <img
                            className="border-0"
                            src={calendarImg}
                            alt="calendar"
                          />
                          <div
                            className={`position-fixed date-calendar z-2 ${
                              showCalendar === true ? "d-block" : "d-none"
                            }`}
                          >
                            <Calendar
                              value={value}
                              minDate={new Date()}
                              onClickDay={(e) => {
                                setValue(e);
                                setshowCalendar(false);
                              }}
                            />
                          </div>
                        </div>
                        <div className="date-input-div w-100">
                          <Form.Select
                            className="register-inputs rounded-0 border-0 clr_dark_grey_4"
                            name="workType"
                            value={individualData.workType}
                            onChange={handleIndividualDataChange}
                          >
                            <option value="" disabled>
                              Work type
                            </option>
                            <option value="1">Pre harvest</option>
                            <option value="2">Post harvest</option>
                          </Form.Select>
                        </div>
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <div className="register-inputs d-flex align-items-center">
                          <input
                            className="register-inputs border-1 px-3 clr_dark_grey_4"
                            type="number"
                            placeholder="Work timings in Hours"
                            name="workTiming"
                            value={individualData.workTiming}
                            onChange={handleIndividualDataChange}
                          />
                          {/* <img src={greenClock} alt="" /> */}
                        </div>
                        <input
                          className="register-inputs mt-4 mt-md-0 px-3 clr_dark_grey_4"
                          type="text" // ⚠️ Use "text" instead of "number" to allow control over leading zeros & length
                          placeholder="Account Number"
                          value={contractorData.accountNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only digits
                            const numericOnly = value.replace(/\D/g, "");
                            setContractorData({
                              ...contractorData,
                              accountNumber: numericOnly,
                            });
                          }}
                          maxLength={18}
                        />
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="IFSC Code"
                          maxLength={11} // IFSC code is exactly 11 characters
                          value={contractorData.IFSCcode}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase(); // Convert to uppercase
                            const alphanumericOnly = value.replace(
                              /[^A-Z0-9]/g,
                              ""
                            ); // Remove non-alphanumeric
                            setContractorData({
                              ...contractorData,
                              IFSCcode: alphanumericOnly,
                            });
                          }}
                        />
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Location"
                          name="location"
                          value={individualData.location}
                          onChange={handleIndividualDataChange}
                        />
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Any terms and conditions"
                          name="termAndCondition"
                          value={individualData.termAndCondition}
                          onChange={handleIndividualDataChange}
                        />
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Name"
                          name="name"
                          value={farmerData.name}
                          onChange={handleFarmerDataChange}
                        />
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Agriculture land"
                          name="agricultureLand"
                          value={farmerData.agricultureLand}
                          onChange={handleFarmerDataChange}
                        />
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="tel"
                          placeholder="Mobile"
                          name="mobile"
                          value={farmerData.mobile}
                          maxLength={10}
                          onInput={(e) => {
                            e.target.value = e.target.value
                              .replace(/[^0-9]/g, "")
                              .slice(0, 10);
                          }}
                          onChange={handleFarmerDataChange}
                        />
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="email"
                          placeholder="Email Id"
                          name="email"
                          value={farmerData.email}
                          onChange={(e) => {
                            handleFarmerDataChange(e);
                          }}
                        />
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Location"
                          name="location"
                          value={farmerData.location}
                          onChange={handleFarmerDataChange}
                        />
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Details of crop"
                          name="detailsOfCrop"
                          value={farmerData.detailsOfCrop}
                          onChange={handleFarmerDataChange}
                        />
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <div
                          onClick={() => setshowCalendar(true)}
                          className="w-100 d-flex align-items-center date-input-div pe-2 cursor_pointer"
                        >
                          <input
                            className="register-inputs bg-transparent border-0 px-3 clr_dark_grey_4"
                            type="text"
                            value={formatDate(value)}
                            placeholder="Dates of availability"
                            disabled
                          />
                          <img
                            className="border-0"
                            src={calendarImg}
                            alt="calendar"
                          />
                          <div
                            className={`position-fixed date-calendar z-2 ${
                              showCalendar === true ? "d-block" : "d-none"
                            }`}
                          >
                            <Calendar
                              value={value}
                              minDate={new Date()}
                              onClickDay={(e) => {
                                setValue(e);
                                setshowCalendar(false);
                              }}
                            />
                          </div>
                        </div>
                        <div className="date-input-div w-100">
                          <Form.Select
                            className="register-inputs rounded-0 border-0 clr_dark_grey_4"
                            name="workType"
                            value={farmerData.workType}
                            onChange={handleFarmerDataChange}
                          >
                            <option value="" disabled>
                              Work type
                            </option>
                            <option value="1">Pre harvest</option>
                            <option value="2">Post harvest</option>
                          </Form.Select>
                        </div>
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-between">
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="number"
                          placeholder="Number of labour required"
                          name="numberOfLabour"
                          value={farmerData.numberOfLabour}
                          onChange={handleFarmerDataChange}
                        />
                        <input
                          className="register-inputs px-3 clr_dark_grey_4"
                          type="text"
                          placeholder="Any terms and conditions"
                          name="termAndCondition"
                          value={farmerData.termAndCondition}
                          onChange={handleFarmerDataChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              <button
                onClick={sendContractorData}
                style={{ maxWidth: "350px", height: "40px", lineHeight: "0" }}
                className="common-darkgreen-button w-100 py-2 text-white rounded-2 mt-5 ff_heebo fw-medium"
              >
                Submit
              </button>
            </div>
          </Col>
          <Col lg={3}>
            <div className="bg_dark_green p-3 rounded-2">
              <FeatureAdds
                mt0="mt-0"
                textwhite="text-white"
                whitehrline="white-hr-line"
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HireFarmLabour;
